'use client';

import { useCallback } from 'react';
import { TakeProfitStopLossButton } from 'src/components/Buttons/TakeProfitStopLossButton';
import useModal from 'src/components/Modals/hooks/useModal';
import { AccountOpenPosition } from 'src/@types/positions';

interface TpSlCellProps {
	position: AccountOpenPosition;
}

export function TpSlCell({ position }: TpSlCellProps) {
	const { show } = useModal();

	const handleOpenTpSlModal = useCallback(() => {
		show({
			type: 'tp_sl',
			props: { marketIndex: position.marketIndex },
		});
	}, [show, position.marketIndex]);

	if (position.isIsolatedBalanceOnly) {
		return <span className="text-text-secondary">-</span>;
	}

	return (
		<TakeProfitStopLossButton
			position={position}
			handleOpenTpSlModal={handleOpenTpSlModal}
		/>
	);
}
